module.exports = __webpack_public_path__ + "static/media/Notifications.e51d44e5.svg";